import { SIMULATOR_PATH } from '../components/organisms/SmartChargingSimulator/simulatorUrl';

/** Rota que dá acesso ao formulário de smart charging do grupo. */
export const VIRTUAL_GROUP_VIEW_PATH = '/virtual-groups/view/:id';

type RouteLike = { path?: string } | false | null | undefined;

/**
 * O simulador (MV2-2006) não tem permissão própria no CS: quem enxerga o grupo, e portanto o
 * formulário de smart charging que abre o simulador, enxerga o simulador. Sem isso a rota nova
 * exigiria cadastrar permissão por usuário.
 */
export const withSmartChargingSimulator = <T extends RouteLike>(mappedRoutes: T[] | undefined, staticRoutes: any[]) => {
  if (!mappedRoutes) {
    return mappedRoutes;
  }

  const canViewGroup = mappedRoutes.some((route) => route && route.path === VIRTUAL_GROUP_VIEW_PATH);
  const alreadyMapped = mappedRoutes.some((route) => route && route.path === SIMULATOR_PATH);
  const simulator = staticRoutes.find(({ path }) => path === SIMULATOR_PATH);

  return canViewGroup && !alreadyMapped && simulator ? [...mappedRoutes, simulator] : mappedRoutes;
};
